module.exports = __webpack_public_path__ + "static/media/Colette Stripe King Headboard - 180 cm_Teal.dd59877c.png";